module.exports = __webpack_public_path__ + "static/img/fuwu5.abb6668.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/productAndService/fuwu5.png
// module id = swDU
// module chunks = 1